import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Order } from '@accounting/interfaces/order';
import { Invoice } from '@accounting/interfaces/invoice';

@Component({
  name: 'bpc-export-pos-checkout-modal',
  components: {},
})
export default class ExportPosCheckoutModal extends Vue {
  @Prop({ type: String, required: true }) readonly entityName: string;
  @Prop({ type: String, default: 'export-pos-checkout-modal' })
  readonly exportCheckoutModalId: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly toAddArticle: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly orders: Order[];
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly openTickets: Invoice[];

  selectedInvoice: Invoice = null;
  selectedOrders: Order[] = [];

  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  get inPosCheckoutOpenTicket() {
    return this.openTickets.filter(ticket => {
      return ticket.status == 'to_pay';
    });
  }

  get availableOpenTickets() {
    const newTicket = [{ text: `${this.$t('global.pos.new_ticket')}`, value: null }];
    const openTickets = this.inPosCheckoutOpenTicket.map(ticket => {
      return {
        text: `${ticket.code} - 
            ${ticket.contact ? ticket.contact.fullname + ' - ' : ''} 
            ${ticket.total_amount}€`,
        value: ticket,
      };
    });
    return newTicket.concat(openTickets);
  }

  get availableOrders() {
    return this.orders.map(order => {
      return {
        text: `${order.code} - 
            ${order.description ? order.description + ' - ' : ''}
            ${this.$t('accounting.orders.status.' + order.status + '.label')} -  
            ${order.total_price}€`,
        value: order,
        disabled: (order.type !== 'attendee' && order.status !== 'waiting') || (order.type === 'attendee' && (order.status !== 'waiting' && order.status !== 'shopping_cart')),
      };
    });
  }

  get exportModalTitle() {
    return this.$t('global.modals.export_pos_checkout.title', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get exportModalBody() {
    return this.$t('global.modals.export_pos_checkout.body', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get selectOpenTicketLabel() {
    return this.$t('global.pos.choose_open_ticket.label');
  }

  get selectOrderLabel() {
    return this.$t('global.pos.choose_order.label');
  }

  onSelectOrder() {
    this.$emit('select-order-clicked', this.selectedOrders);
  }

  onSelectInvoice() {
    this.$emit('select-invoice-clicked', this.selectedInvoice);
  }

  closeModal() {
    this.resetSelectedData();
    this.$emit('close-modal');
  }

  openModal() {
    this.resetSelectedData();

    // Select new ticket by default
    this.selectedInvoice = null;
    this.$emit('select-invoice-clicked', this.selectedInvoice);

    // Select all available orders by default
    if (this.orders.length > 0) {
      this.selectedOrders = this.orders.filter(order => order.status === 'waiting' || (order.type === 'attendee' && order.status === 'shopping_cart'));
      this.$emit('select-order-clicked', this.selectedOrders);
    }

    this.$bvModal.show(this.exportCheckoutModalId);
  }
  onConfirmExportToPosCheckout() {
    this.$emit('export-pos-checkout-clicked');
  }

  resetSelectedData() {
    this.selectedInvoice = null;
    this.selectedOrders = [];
  }

  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.exportCheckoutModalId);
    }
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
